(() => {
  const observedFrames = new WeakSet();

  const hydrateVideo = (frame) => {
    if (frame.dataset.videoHydrated === 'true') return;

    const video = frame.querySelector('video');
    if (!video) return;

    const deferredPoster = video.getAttribute('data-poster');
    if (deferredPoster) {
      video.poster = deferredPoster;
      video.removeAttribute('data-poster');
    }

    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });

    if (video.hasAttribute('data-deferred-autoplay')) {
      video.setAttribute('autoplay', '');
      video.removeAttribute('data-deferred-autoplay');
    }

    frame.dataset.videoHydrated = 'true';
    frame.isAutoplay = video.hasAttribute('autoplay');

    if (frame.hasAttribute('data-deferred-responsive-video') && typeof frame.initResponsiveVideo === 'function') {
      frame.setAttribute('data-responsive-video', '');
      frame.removeAttribute('data-deferred-responsive-video');
      frame.isResponsive = true;
      frame.initResponsiveVideo();
      video.load();
    } else {
      video.load();
    }

    const frameRect = frame.getBoundingClientRect();
    const isInViewport = frameRect.bottom > 0 && frameRect.top < window.innerHeight;
    if (frame.isAutoplay && isInViewport && typeof frame.play === 'function') {
      frame.play();
    }
  };

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            hydrateVideo(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '400px 0px', threshold: 0 })
    : null;

  const observeVideos = (root = document) => {
    root.querySelectorAll('video-frame[data-deferred-video]').forEach((frame) => {
      if (observedFrames.has(frame)) return;
      observedFrames.add(frame);

      if (observer) {
        observer.observe(frame);
      } else {
        hydrateVideo(frame);
      }
    });
  };

  observeVideos();
  document.addEventListener('shopify:section:load', (event) => observeVideos(event.target));
})();
